export default "__VITE_ASSET__7620f3d3__"